<div class="mb-4">
  <!-- Default option buttons -->
  <span class="fw-normal mb-2 d-block">
    {{ 'product-variant-optie-selecteer-optie-prefix' | fromDictionary }}
    <span>{{ variantLabel(option.name) }}</span>
    @if (getSelectedOptionValue(option.name); as val) {
      -
      <span>{{ val }}</span>
    }
  </span>

  <ul class="button-list">
    @for (value of option.values; track value) {
      <li class="button-list__item">
        <a
          class="button button-outline button--secondary"
          [class.is--active]="getSelectedOptionValue(option.name) === value"
          [class.is--inactive]="!isAvailable(option.name, value)"
          [routerLink]="[]"
          [queryParams]="getOptionAsQueryParam(option, value)"
          [queryParamsHandling]="'merge'"
          [replaceUrl]="true"
        >
          {{ value }}
        </a>
      </li>
    }
  </ul>
</div>
